module.exports = __webpack_public_path__ + "img/greece.b54e0c7b.svg";